import { render, staticRenderFns } from "./AlarmsLogsComponent.vue?vue&type=template&id=59bf7d0a&scoped=true"
import script from "./AlarmsLogsComponent.vue?vue&type=script&lang=js"
export * from "./AlarmsLogsComponent.vue?vue&type=script&lang=js"
import style0 from "./AlarmsLogsComponent.vue?vue&type=style&index=0&id=59bf7d0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf7d0a",
  null
  
)

export default component.exports